import { BLOCKS } from '@contentful/rich-text-types'
export default {
  [BLOCKS.EMBEDDED_ENTRY]: (node, key, h, next) =>
    h('div', { key }, next(node.content, key, h, next)),
}
